import {
    SET_GLOBAL_DATA,
    CUSTOMER_DATA,
    DISTRIBUTOR_DATA,
    SET_PREVGLOBAL_DATA
} from './types';

const reducers = (state: any = {}, action: any) => {
    switch (action.type) {
        case SET_GLOBAL_DATA: {
            let globaldata = state?.globaldata ?? {};
            globaldata = { ...globaldata, ...action.globaldataValues };
            return {
                ...state, globaldata
            };
        }
        case CUSTOMER_DATA:
            let customerdata = state?.globaldata ?? {};
            customerdata = { ...customerdata, ...action.values };
            return {
                ...state, customerdata
            }
        case DISTRIBUTOR_DATA:
            let distributordata = state?.globaldata ?? {};
            distributordata = { ...distributordata, ...action.values };
            return {
                ...state, distributordata
            }
        case SET_PREVGLOBAL_DATA: {
            let prevglobalData = state?.prevglobalData ?? {};
            prevglobalData = { ...prevglobalData, ...action.globaldataValues };
            return {
                ...state, prevglobalData
            };
        }
        default:
            return state;
    }
};

export default reducers;




